import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TrovityLogo from 'src/assets/Buy_Policy_Images/TrovityIcon.svg'
import ManualLogo from 'src/assets/Buy_Policy_Images/Settings.svg'
import HealthInsuranceDetailsManual from 'src/components/BuyPolicy/insuranceScreens/health/HealthInsuranceDetailsManual'
import {
  HEALTH_POLICY_PERIOD_OPTIONS,
  HEALTH_SUM_ASSURED_OPTIONS,
  INSURANCE_CATOGORIES,
} from 'src/utils/constants/BuyPolicy'
import HealthInsuranceDetailsTrovity from 'src/components/BuyPolicy/insuranceScreens/health/HealthInsuranceDetailsTrovity'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useHistory } from 'react-router-dom'
import { Divider } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import {
  getInsuranceDetails,
  getTrovityInsuranceDetails,
} from 'src/services/buyPolicyService'
import { useDispatch, useSelector } from 'react-redux'
import { scrollToTop } from 'src/utils/commonMethods'
import { getTokenForQrReport } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  clearCompareList,
  showNotificationMessage,
  updatePolicyTenurePeriod,
  updateQuickQuoteFilters,
  updateTrust,
} from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const HealthInsuranceDetails = () => {
  const classes = useStyles()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  const history = useHistory()
  const [selectedContainer, setSelectedContainer] = useState(
    guestUserDetails?.trust
  )
  const [sumInsured, setSumInsured] = useState(
    guestUserDetails?.quickQuoteFilters?.sumInsured
  )
  const [policyPeriod, setPolicyPeriod] = useState(
    guestUserDetails?.quickQuoteFilters?.policyPeriod
  )
  const [loading, setLoading] = useState(false)
  const [insuranceQuotesManual, setInsuranceQuotesManual] = useState([])
  const [insuranceQuotesTrovity, setInsuranceQuotesTrovity] = useState([])
  const [numberOfQuotes, setNumberOfQuotes] = useState(0)

  const [token, setToken] = useState(null)
  const dispatch = useDispatch()

  const isManualSelected = () => {
    return selectedContainer === INSURANCE_CATOGORIES?.manualSelection
  }

  useEffect(() => {
    scrollToTop()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (token) {
      fetchInsuranceDetails(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContainer, guestUserDetails?.userDetails])

  useEffect(() => {
    if (token && isManualSelected()) {
      fetchInsuranceDetailsManual(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sumInsured, policyPeriod])

  const handleContainerSelect = (container) => {
    setSelectedContainer(container)
    dispatch(updateTrust(container))
  }

  const handleBack = () => {
    history.push('/individual/dashboard/buyPolicy/health/')
  }

  const handleSumAssured = (e) => {
    dispatch(
      updateQuickQuoteFilters({
        sumInsured: e?.target?.value,
        policyPeriod,
      })
    )
    setSumInsured(e?.target?.value)
  }

  const handlePolicyPeriod = (e) => {
    dispatch(
      updateQuickQuoteFilters({
        sumInsured,
        policyPeriod: e?.target?.value,
      })
    )
    dispatch(updatePolicyTenurePeriod(e?.target?.value))
    setPolicyPeriod(e?.target?.value)
  }

  const getHeading = () => {
    if (!isManualSelected()) {
      return (
        <>
          <div className={classes.headingContainer}>
            <span className={classes.heading}>
              Trovity&apos;s Insurance Categories&nbsp;
              <span className={classes.subheading}>
                for You and Your Family
              </span>
            </span>
          </div>
          <div className={classes.headingSubText}>
            Leave it to trovity, the insurance wizard, to find your perfect
            policy match
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className={classes.headingContainer}>
            <span className={classes.customizeHeading}>
              Customize your policy&nbsp;
              <span className={classes.plansText}>
                {numberOfQuotes} best plans for you
              </span>
            </span>
          </div>
        </>
      )
    }
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      setToken(token)
      fetchInsuranceDetails(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchInsuranceDetails = (token) => {
    if (isManualSelected()) {
      fetchInsuranceDetailsManual(token)
    } else {
      fetchInsuranceDetailsTrovity(token)
    }
  }
  const fetchInsuranceDetailsManual = async (token) => {
    setLoading(true)

    const formData = {
      ...guestUserDetails.userDetails,
      sumInsured: Number(sumInsured),
      policyPeriod: Number(policyPeriod),
      membersInfo: [...guestUserDetails?.memberDetails],
    }
    const response = await getInsuranceDetails(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setInsuranceQuotesTrovity([])
        setNumberOfQuotes(0)
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setInsuranceQuotesManual(responseData?.quoteDetails)
        setNumberOfQuotes(responseData?.quoteDetails?.length)
        dispatch(clearCompareList())
      } else {
        setInsuranceQuotesManual([])
        setNumberOfQuotes(0)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      setInsuranceQuotesTrovity([])
      setNumberOfQuotes(0)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const fetchInsuranceDetailsTrovity = async (token) => {
    setLoading(true)

    const formData = {
      ...guestUserDetails?.userDetails,
      membersInfo: [...guestUserDetails?.memberDetails],
    }
    const response = await getTrovityInsuranceDetails(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setInsuranceQuotesTrovity([])
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setInsuranceQuotesTrovity(responseData)
        dispatch(clearCompareList())
      } else {
        setInsuranceQuotesTrovity([])
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      setInsuranceQuotesTrovity([])
      setNumberOfQuotes(0)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div
          className={`${classes.headerContainer} ${
            isManualSelected() ? classes.manualHeadingContainer : null
          }`}
        >
          <div>
            <div
              onClick={handleBack}
              className={classes.goBackButtonContainer}
              id='backButton'
            >
              <img src={arrow} alt='arrow' />
              <span className={classes.gotoBackButton}>Go back</span>
            </div>
            {getHeading()}
          </div>
          <div>
            <div className={classes.switchContainer}>
              <div className={classes.switchContainerMain}>
                <div
                  className={`${classes.insuranceCategoryContainer} ${
                    selectedContainer === INSURANCE_CATOGORIES?.trustTrovity
                      ? classes.selected
                      : classes.notSelected
                  }`}
                  onClick={() =>
                    handleContainerSelect(INSURANCE_CATOGORIES?.trustTrovity)
                  }
                  id='trustTrovity'
                >
                  <div className={classes.trustTrovityLogoContainer}>
                    <img
                      src={TrovityLogo}
                      alt='trustTrovity-logo'
                      className={classes.trustTrovityLogo}
                    />
                  </div>
                  <div className={classes.trustTrovityText}>
                    I Trust Trovity
                  </div>
                </div>
                <div
                  className={`${classes.insuranceCategoryContainer} ${
                    selectedContainer === INSURANCE_CATOGORIES?.manualSelection
                      ? classes.selected
                      : classes.notSelected
                  }`}
                  onClick={() =>
                    handleContainerSelect(INSURANCE_CATOGORIES?.manualSelection)
                  }
                  id='trustManual'
                >
                  <div className={classes.manualLogo}>
                    <img src={ManualLogo} alt='chooseManually-logo' />
                  </div>
                  <div className={classes.manualText}>Choose Manually</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isManualSelected() && (
          <div className={classes.filtersContainer}>
            <div className={classes.dropdownContainer}>
              <div className={classes.dropdown}>
                <select
                  id={'sumAssured'}
                  name={'sumAssured'}
                  value={sumInsured}
                  placeholder={'Sum Insured'}
                  onChange={handleSumAssured}
                  className={classes.commonStyle}
                >
                  <option value={0} disabled>
                    Sum Insured
                  </option>

                  {HEALTH_SUM_ASSURED_OPTIONS?.map((item) => {
                    return (
                      <option key={item?.value} value={item?.value}>
                        {item?.title}
                      </option>
                    )
                  })}
                </select>
                {/* Sum Assured <img src={Dropdown} alt={'Dropdown'} className={classes.dropdownIcon} /> */}
              </div>
              <div className={classes.dropdown}>
                <select
                  id={'policyPeriod'}
                  name={'policyPeriod'}
                  value={policyPeriod}
                  placeholder={'Policy Period'}
                  onChange={handlePolicyPeriod}
                  className={classes.commonStyle}
                >
                  <option value={0} disabled>
                    Policy Period
                  </option>
                  {HEALTH_POLICY_PERIOD_OPTIONS?.map((item) => {
                    return (
                      <option key={item?.value} value={item?.value}>
                        {item?.title}
                      </option>
                    )
                  })}
                </select>
              </div>
              {/* <div className={classes.dropdown}>
              Insurer <img src={Dropdown} alt={'Dropdown'} className={classes.dropdownIcon} />
            </div>
            <div className={classes.dropdown}>
              PED waiting period{' '}
              <img src={Dropdown} alt={'Dropdown'} className={classes.dropdownIcon} />
            </div>
            <div className={classes.dropdown}>
              Premium <img src={Dropdown} alt={'Dropdown'} className={classes.dropdownIcon} />
            </div> */}
            </div>
            <div className={classes.sortContainer}>
              {/* <Button variant={'contained'} className={classes.sortByButton}>*/}
              {/*  <span>Sort By</span>*/}
              {/* </Button>*/}
            </div>
          </div>
        )}

        <Divider />

        <div>
          {!isManualSelected() && !loading ? (
            <HealthInsuranceDetailsTrovity
              insuranceQuotes={insuranceQuotesTrovity}
              loading={loading}
            />
          ) : (
            <HealthInsuranceDetailsManual
              insuranceQuotes={insuranceQuotesManual}
              loading={loading}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default HealthInsuranceDetails

export const useStyles = makeStyles({
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  switchContainer: {
    backgroundColor: '#E7F5FB',
    borderRadius: 10,
  },
  switchContainerMain: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '3px',
    padding: '5px',
  },
  trustTrovityLogoContainer: {
    overflow: 'hidden',
    marginLeft: '-10px',
    width: '35px',
    height: '30px',
  },
  trustTrovityLogo: {
    width: '32.7px',
    height: '30px',
    transform: 'scale(1.1)',
  },
  insuranceCategoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    padding: '0px 10px 0px 10px',
    cursor: 'pointer',
    height: '30px',
  },
  manualLogo: {
    width: '14px',
    height: '14px',
  },
  trustTrovityText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0em',
    color: '#464646',
  },
  manualText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#2BA6C8',
  },
  selected: {
    backgroundColor: 'white',
    borderRadius: 10,
    boxShadow: '0px 4px 4px 0px #00000033',
  },
  notSelected: {},
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  headerContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  manualHeadingContainer: {
    paddingBottom: '20px',
    borderBottom: '1px solid #4DC3E3',
  },
  goBackButtonContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
  heading: {
    fontSize: '17px',
    fontWeight: 600,
    color: '#B92250',
  },
  customizeHeading: {
    fontSize: '17px',
  },
  plansText: {
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#979797',
  },
  subheading: {
    fontSize: '17px',
    fontWeight: 600,
    color: '#000000',
  },
  headingSubText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#656565',
    marginBottom: '1vw',
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #E6E6E6',
  },
  sortContainer: {
    padding: '5px',
  },
  sortByButton: {
    background:
      'linear-gradient(0deg, #BED9E2, #BED9E2),linear-gradient(270deg, #DEF7FF 0%, rgba(217, 217, 217, 0) 100%)',
    border: '1px solid #BED9E2 !important',
    color: `${COLORS.BLACK} !important`,
    width: '100px',
    height: '30px',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdown: {
    borderRight: '1px solid #CACACA',
    padding: '15px',
    cursor: 'pointer',
  },
  dropdownIcon: {
    height: '10px',
    width: '10px',
  },
  commonStyle: {
    border: 'none',
    background: 'none',
    fontSize: '17px',
  },
})
